"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDeviceParameterFilter = exports.DesktopParameterFilter = exports.ParameterFilter = exports.filterCustomParameters = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const checkmarkBlue_svg_1 = __importDefault(require("../../../assets/icons/checkmarkBlue.svg"));
const chevronLeft_svg_1 = __importDefault(require("../../../assets/icons/chevronLeft.svg"));
const chevronRight_svg_1 = __importDefault(require("../../../assets/icons/chevronRight.svg"));
const minus_svg_1 = __importDefault(require("../../../assets/icons/minus.svg"));
const plus_svg_1 = __importDefault(require("../../../assets/icons/plus.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const sensorsSlice_1 = require("../../../store/sensorsSlice");
const sessionFiltersSlice_1 = require("../../../store/sessionFiltersSlice");
const filters_1 = require("../../../types/filters");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const CustomParameterFilter_1 = require("./CustomParameterFilter");
const FilterInfoPopup_1 = require("./FilterInfoPopup");
const S = __importStar(require("./SessionFilters.style"));
const getBasicMeasurementTypes = (sessionType) => sessionType === filters_1.SessionTypes.FIXED
    ? filters_1.FixedBasicParameterTypes
    : filters_1.MobileBasicParameterTypes;
const filterCustomParameters = (parameters, sessionType) => {
    const basicParameters = getBasicMeasurementTypes(sessionType);
    return parameters.filter((param) => !basicParameters.includes(param));
};
exports.filterCustomParameters = filterCustomParameters;
const ParameterFilter = ({ isBasicOpen, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { measurementType } = (0, mapParamsHandler_1.useMapParams)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const basicParametersModalOpen = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectBasicParametersModalOpen);
    const handleShowParametersClick = () => {
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(!basicParametersModalOpen));
        dispatch((0, sessionFiltersSlice_1.setBasicSensorsModalOpen)(false));
    };
    return (react_1.default.createElement(S.SingleFilterWrapper, null,
        react_1.default.createElement(S.SelectedOptionButton, { onClick: handleShowParametersClick, "$isActive": isBasicOpen },
            react_1.default.createElement(S.SelectedOptionHeadingWrapper, null,
                react_1.default.createElement(S.SelectedOptionHeading, { "$isSelected": isBasicOpen }, t("filters.parameter")),
                react_1.default.createElement(S.SelectedOption, { "$isSelected": isBasicOpen }, measurementType)),
            react_1.default.createElement(S.ChevronIcon, { "$src": chevronRight_svg_1.default, "$isActive": isBasicOpen })),
        react_1.default.createElement(FilterInfoPopup_1.FilterInfoPopup, { filterTranslationLabel: "filters.parameterInfo" })));
};
exports.ParameterFilter = ParameterFilter;
const DesktopParameterFilter = () => {
    const [isBasicOpen, setIsBasicOpen] = (0, react_1.useState)(false);
    const [moreOpen, setMoreOpen] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { measurementType, sessionType, setParameterParams } = (0, mapParamsHandler_1.useMapParams)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const sensors = (0, hooks_1.useAppSelector)(sensorsSlice_1.selectSensors);
    const parameters = (0, hooks_1.useAppSelector)(sensorsSlice_1.selectParameters);
    const customParameters = (0, exports.filterCustomParameters)(parameters, sessionType);
    const basicParametersModalOpen = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectBasicParametersModalOpen);
    const customParametersModalOpen = (0, hooks_1.useAppSelector)(sessionFiltersSlice_1.selectCustomParametersModalOpen);
    const handleOnMoreClick = () => {
        setMoreOpen(!moreOpen);
    };
    const handleSelectParameter = (selectedParameter) => {
        setParameterParams(selectedParameter, sensors);
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false));
        dispatch((0, mapSlice_1.setFetchingData)(true));
    };
    (0, react_1.useEffect)(() => {
        setIsBasicOpen(basicParametersModalOpen);
        setMoreOpen(customParametersModalOpen);
    }, [basicParametersModalOpen, customParametersModalOpen]);
    return (react_1.default.createElement(S.Wrapper, null,
        react_1.default.createElement(exports.ParameterFilter, { isBasicOpen: isBasicOpen }),
        !isMobile && isBasicOpen && (react_1.default.createElement(S.FiltersOptionsWrapper, null,
            react_1.default.createElement(S.BasicParameterWrapper, null,
                react_1.default.createElement(S.FiltersOptionHeading, null, t("filters.parameter")),
                getBasicMeasurementTypes(sessionType).map((item, id) => (react_1.default.createElement(S.FiltersOptionButton, { "$isSelected": item === measurementType, key: id, onClick: () => handleSelectParameter(item) }, item))),
                customParameters.length > 0 && (react_1.default.createElement(S.SeeMoreButton, { onClick: () => setMoreOpen(!moreOpen) },
                    react_1.default.createElement(S.SeeMoreSpan, null, t(`filters.${moreOpen ? "seeLess" : "seeMore"}`)),
                    react_1.default.createElement("img", { src: moreOpen ? minus_svg_1.default : plus_svg_1.default, alt: "" })))),
            moreOpen && (react_1.default.createElement(CustomParameterFilter_1.CustomParameterFilter, { customParameters: customParameters }))))));
};
exports.DesktopParameterFilter = DesktopParameterFilter;
const MobileDeviceParameterFilter = ({ customParameters, sessionsCount, onClose, fetchableSessionsCount, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const sensors = (0, hooks_1.useAppSelector)(sensorsSlice_1.selectSensors);
    const { t } = (0, react_i18next_1.useTranslation)();
    const { measurementType, setParameterParams, sessionType } = (0, mapParamsHandler_1.useMapParams)();
    const fixedSessionTypeSelected = sessionType === filters_1.SessionTypes.FIXED;
    const handleSelectParameter = (0, react_1.useCallback)((selectedParameter) => {
        setParameterParams(selectedParameter, sensors);
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false));
        dispatch((0, mapSlice_1.setFetchingData)(true));
    }, [sensors]);
    const handleShowMoreClick = () => {
        dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false));
        dispatch((0, sessionFiltersSlice_1.setCustomParametersModalOpen)(true));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.ModalContent, null,
            react_1.default.createElement(S.Header, null,
                react_1.default.createElement(S.ChevronBackButton, { onClick: () => dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false)) },
                    react_1.default.createElement("img", { src: chevronLeft_svg_1.default, alt: t("filters.back") })),
                react_1.default.createElement(S.HeaderTitle, null, t("filters.selectParameter"))),
            react_1.default.createElement(S.Description, null, t("filters.selectParameterDescription")),
            react_1.default.createElement(S.BasicParameterButtonsWrapper, null, getBasicMeasurementTypes(sessionType).map((item, id) => (react_1.default.createElement(S.BasicParameterButton, { key: id, onClick: () => handleSelectParameter(item) },
                react_1.default.createElement(S.ButtonSpan, { "$isActive": item === measurementType }, item),
                item === measurementType && (react_1.default.createElement("img", { src: checkmarkBlue_svg_1.default, alt: t("filters.altCheckmark") })))))),
            customParameters.length > 0 && (react_1.default.createElement(S.GrayButton, { onClick: handleShowMoreClick }, t("filters.showCustomParameters")))),
        react_1.default.createElement(S.ButtonsWrapper, null,
            react_1.default.createElement(S.BackButton, { onClick: () => dispatch((0, sessionFiltersSlice_1.setBasicParametersModalOpen)(false)) }, t("filters.back")),
            react_1.default.createElement(S.MinorShowSessionsButton, { onClick: onClose }, fixedSessionTypeSelected ? (react_1.default.createElement(react_1.default.Fragment, null,
                t("filters.showSessions"),
                " (",
                sessionsCount,
                ")")) : (react_1.default.createElement(react_1.default.Fragment, null,
                t("filters.showSessions"),
                " ",
                t("map.results", {
                    results: sessionsCount,
                    fetchableSessionsCount,
                })))))));
};
exports.MobileDeviceParameterFilter = MobileDeviceParameterFilter;
